<template>
    <div>
        <div class="m-menu-icon">
            <button class="b-menu" type="button" @click="is_modal = !is_modal">〓</button>
        </div>
        <div id="myModal" class="modal" v-if="is_modal">
            <!-- Modal content -->
            <div class="modal-content">
                <div class="modal-header">
                    <span class="close" @click="closeEvent()">&times;</span>
                    <h2>관리자 메뉴</h2>
                </div>
                <div class="modal-body">
                    <!-- <ConsultCancel :account="account" :note="chosen_note" :status="note_status" :is_admin="is_admin" ref="ConsultCancel" @setCancel="setCancel"></ConsultCancel> -->
                    <p class="m-menu"><a href="" @click.prevent="$router.push(`/consult-pharm-monit`)">조제/배송현황</a></p>
                    <p class="m-menu"><a href="" @click.prevent="$router.push(`/dr_admin/mobile`)">약국관리</a></p>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
export default {
  name: 'mobile-menu',
  data () {
    return {
        is_modal: false
    }
  },
  methods: {
    closeEvent() {
      this.is_modal = false;
    },
  },
  components: {
    
  }
}
</script>

<style scoped>
    /* Contents
------------------------------------------------------- */

/* Main */
.wrap {
    width: 100%;
    max-width: 1080px;
    margin: 55px auto;
}

.home-card {
    float: left;
    width: 530px;
    min-height: 370px;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 2px 2px 5px rgba(50, 50, 50, .1);
}

.home-card:nth-of-type(even) {
    margin-right: 0;
}

.m-menu-icon {
  float: right;
  margin-right: 10px;
  /* width: 530px; */
}

.b-menu {
  width: 40px;
  font: 400 16px 'Noto Sans KR', sans-serif;
}

.m-menu {
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 0 5px;
  font: 400 16px 'Noto Sans KR', sans-serif;
}

/* The Modal (background) */
    .modal {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        opacity:0.99;
        z-index: 100; /* Sit on top */
        padding-top: 200px; /* Location of the box */
        right: 20px;
        top: 90px;
        width: 40%; /* Full width */
        height: 50%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(9,9,9); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content */
    .modal-content {
        position: relative;
        background-color: #fefefe;
        margin: auto;
        margin-top: 0;
        /* margin-top: 100px; */
        padding: 0;
        border: 1px solid #888;
        /* width: 100%; */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
    }

    /* Add Animation */
    @-webkit-keyframes animatetop {
        from {top:-300px; opacity:0} 
        to {top:0; opacity:1}
    }

    @keyframes animatetop {
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    }

    /* The Close Button */
    .close {
        margin-top: -5px;
        color: white;
        float: right;
        font-size: 25px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .modal-header {
        padding: 10px;
        margin-bottom: 10px;
        background-color: #111;
        color: white;
    }

    .modal-body {padding: 0px 0px;}

    .modal-footer {
        padding: 2px 5px;
        background-color: #111;
        color: white;
    }
</style>
